import {ContactInfoModal} from "layout"
import HeaderModal from "layout/modals/HeaderModal";
import React, {useSelector} from 'react-redux'

const Contact = () => {
    const { contact } = useSelector((state) => state.content);

        return <>
                <HeaderModal headerText={contact['header']} headerTag={"h1"}/>
                <div id="contact-modal">
                    <div id="contact-info">
                        <ContactInfoModal header={contact.information.name} content={"Daniele Giulio Moles"}/>
                        <ContactInfoModal header={contact.information.phone} content={"+39 338 61 25 600"}/>
                        <ContactInfoModal header={contact.information.email} content={"danielemoles@hotmail.com"} />
                    </div>
                </div>
                
            </>
}


export default Contact;